import { useContext, useLayoutEffect } from 'react';

import { PeopleAccessHeaderContext } from '../context/PeopleAccessHeaderContext.js';

/**
 * A list page that renders `PeopleAccessHeader` inside its own sticky band calls this, so the
 * layout does not render a second header above it. Released when the page unmounts.
 */
export const useOwnPeopleAccessHeader = () => {
  const { claimHeader } = useContext(PeopleAccessHeaderContext);

  useLayoutEffect(() => claimHeader(), [claimHeader]);
};
